// IT autsorsing — xizmat sahifasi kontenti (uz / ru)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "IT autsorsing — dasturchi va jamoa ijarasi oyiga 16 mln so'mdan | Innobek",
        description:
            "IT autsorsing: tajribali dasturchi yoki to'liq jamoa oyiga 16 000 000 so'mdan. Ishga qabul, soliq va ta'til tashvishisiz. Kod sizniki, NDA, 2 hafta sinov davri.",
        keywords: [
            "it autsorsing",
            "dasturchi yollash",
            "jamoa ijaraga olish",
            "dedicated team",
            "masofaviy dasturchi",
            "it autsorsing narxi",
            "autsorsing jamoa",
            "it bo'limi autsorsing",
        ],
    },

    hero: {
        eyebrow: "IT autsorsing",
        h1: "IT autsorsing: tayyor jamoani oyiga ijaraga oling",
        lead:
            "O'z IT bo'limingizni qurish uchun ishga qabul, soliq, ta'til, texnika va o'quv kerak — bu odatda 3–6 oy va ko'p pul. Autsorsingda siz faqat ishlagan jamoaga to'laysiz: dasturchi 1–2 haftada loyihangizga qo'shiladi, kod birinchi kundan sizning repozitoriyingizda bo'ladi.",
        ctaPrimary: "Jamoa uchun ariza qoldirish",
        ctaSecondary: "Narx va modellarni ko'rish",
        proof: [
            "200+ topshirilgan loyiha",
            "1–2 haftada boshlash",
            "Kod va huquqlar to'liq sizniki",
            "NDA har bir hamkorlikda",
            "Birinchi 2 hafta — sinov davri",
        ],
    },

    intro: {
        h: "IT autsorsing nima va u kimga foyda beradi?",
        p: [
            "IT autsorsing — kompaniya o'z shtatida dasturchi saqlash o'rniga, kerakli mutaxassislarni tashqi jamoadan olishi. Siz vazifani qo'yasiz, biz esa dasturchi, tester, dizayner yoki DevOps muhandisini ajratamiz. Ular sizning loyihangizda, sizning prioritetlaringiz va kalendaringiz bo'yicha ishlaydi.",
            "Asosiy farq xarajat tarkibida. Shtatdagi dasturchi uchun siz maoshdan tashqari soliq, ta'til, kasallik varaqasi, noutbuk, litsenziya, ish joyi va o'quvni to'laysiz. Ishga qabul jarayonining o'zi 1–3 oy vaqt oladi va har doim ham natija bermaydi. Autsorsingda bularning hammasi bitta oylik summaga kiradi va siz uni oldindan bilasiz.",
            "Innobek uchun autsorsing «soat sotish» emas. Har bir hamkorlikka texnik rahbar biriktiriladi — u arxitektura, kod sifati va muddat uchun javob beradi. Siz dasturchini har kuni nazorat qilib o'tirmaysiz: kunlik stand-up, haftalik demo va oy oxirida bajarilgan ishlar hisoboti beriladi.",
            "Modelni ham siz tanlaysiz. Ish hajmi to'lqinsimon va aniq emas bo'lsa — soatbay model qulay: soatlar sanaladi, har oy faktura shu bo'yicha chiqadi. Ish doimiy va rejalashtirilgan bo'lsa — oylik model 25–35% arzonroq tushadi, chunki mutaxassis vaqti to'liq sizga ajratiladi va boshqa loyihaga o'tmaydi.",
            "Kod mulkchiligi bo'yicha savol tez-tez chiqadi, shuning uchun ochiq javob beramiz: barcha kod, dizayn manbalari va hujjatlar sizniki. Ish birinchi kundan sizning Git repozitoriyingizda olib boriladi. Biz kalitni ushlab turmaymiz, shartnomani to'xtatganingizda hech narsani «bloklamaymiz».",
            "Bu xizmat hammaga ham mos emas. Agar sizga bir martalik kichik vazifa kerak bo'lsa — masalan, bitta landing sahifa — uni loyiha sifatida buyurtma qilgan arzonroq chiqadi va biz buni ochiq aytamiz. Autsorsing o'zini oqlaydigan holat: ish doimiy, bir necha oy davom etadi va sizda uni olib boradigan texnik odam yo'q.",
        ],
    },

    definition: {
        term: "IT autsorsing nima?",
        text:
            "IT autsorsing — kompaniya o'z shtatida IT mutaxassis saqlash o'rniga, dasturchi yoki to'liq jamoani tashqi hamkordan oylik yoki soatbay shart asosida jalb qilishi. Mutaxassis mijozning jarayoni ichida ishlaydi, kod va huquqlar esa mijozda qoladi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Bular alohida to'lanadigan «qo'shimcha» emas — bazaviy shartda ham bor.",
        items: [
            "Bepul konsultatsiya va vazifa hajmini baholash",
            "Nomzodlarni tanlash va siz bilan tanishtirish",
            "Texnik suhbatni o'zingiz o'tkazish imkoniyati",
            "Sinov davri: birinchi 2 haftada mos kelmasa — almashtiramiz",
            "Noutbuk, litsenziya va ish joyi bizning zimmamizda",
            "Soliq va mehnat munosabatlari bilan bog'liq barcha masalalar",
            "Kunlik stand-up — 15 daqiqa, sizning vaqtingizga moslab",
            "Jira, Trello yoki Notionda vazifa yuritish",
            "Slack yoki Telegramda kunlik aloqa kanali",
            "Texnik rahbar tomonidan kod tekshiruvi (code review)",
            "Haftalik demo va oylik bajarilgan ishlar hisoboti",
            "Sizning Git repozitoriyingizda ishlash",
            "Maxfiylik shartnomasi (NDA) va kirish huquqlari nazorati",
            "Kasallik va ta'til vaqtida o'rin bosuvchi mutaxassis",
            "Shartnomani bir oylik ogohlantirish bilan to'xtatish",
        ],
    },

    benefits: {
        eyebrow: "Nima beradi",
        h: "Autsorsing biznesga nima beradi",
        sub: "Bu xodim yollashning arzon varianti emas — bu boshqa boshqaruv modeli.",
        items: [
            {
                t: "Tez boshlanadi",
                d: "Dasturchini shtatga olish e'londan birinchi kungacha odatda 1–3 oy oladi. Autsorsingda mutaxassis 1–2 haftada loyihaga kirib, birinchi vazifalarni oladi.",
            },
            {
                t: "Xarajat oldindan ma'lum",
                d: "Soliq, ta'til, kasallik varaqasi, texnika, litsenziya va o'quv oylik summaga kiradi. Byudjetni rejalashtirishda kutilmagan qo'shimcha chiqmaydi.",
            },
            {
                t: "Hajmni moslashtirasiz",
                d: "Faol davrda jamoa 2 kishiga kengayadi, tinch davrda bittaga qaytadi. Ishdan bo'shatish, kompensatsiya va noqulay suhbatlar bo'lmaydi.",
            },
            {
                t: "Bir kishiga bog'liq emassiz",
                d: "Dasturchi kasal bo'lsa yoki ishdan ketsa, o'rni jamoa ichidan to'ldiriladi. Hujjatlar va kod sizda bo'lgani uchun topshirish 2–3 kun oladi.",
            },
            {
                t: "Sifat nazorat qilinadi",
                d: "Kod tekshiruvi, texnik hujjat va ichki standartlar majburiy. Bitta dasturchini yolg'iz yollaganingizda uning kodini hech kim ko'rmaydi.",
            },
            {
                t: "Yetishmayotgan mutaxassislik qo'shiladi",
                d: "DevOps, mobil ishlab chiqish yoki testlash bir loyiha uchun kerak bo'lsa, shtatga olish oqlanmaydi. Autsorsingda ularni qisman bandlikda olasiz.",
            },
            {
                t: "Jarayon sizning tomoningizda qoladi",
                d: "Mutaxassis sizning vazifa tizimingizda ishlaydi va sizning yig'ilishlaringizga qo'shiladi. Boshqaruv tashqariga o'tib ketmaydi.",
            },
            {
                t: "Keyin shtatga o'tkazish mumkin",
                d: "Mahsulot o'sib, o'z jamoangizni qurishga qaror qilsangiz, mutaxassisni bosqichma-bosqich o'zingizga o'tkazish shartlari alohida kelishiladi.",
            },
            {
                t: "Tajriba almashinuvi bor",
                d: "Mutaxassis ortida jamoa, texnik rahbar va boshqa loyihalardagi tajriba turadi. Murakkab masala chiqsa, u yolg'iz qolmaydi.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlar uchun",
        h: "IT autsorsing kimlarga mos keladi",
        sub: "O'z IT bo'limini saqlash hali erta yoki umuman oqlanmaydigan holatlar.",
        items: [
            {
                t: "IT bo'limi yo'q kompaniyalar",
                d: "Sayt, ichki tizim yoki ilova kerak, lekin doimiy dasturchi saqlash oqlanmaydi. Ish hajmi yarim stavkaga to'g'ri keladi.",
            },
            {
                t: "Muddat qisilgan jamoalar",
                d: "O'z dasturchilaringiz bor, lekin reliz yaqin. Biz qo'shimcha kuch bo'lib qo'shilamiz va reliz o'tgach chiqib ketamiz.",
            },
            {
                t: "Yetishmayotgan yo'nalish",
                d: "Backend bor, mobil dasturchi yo'q. Yoki DevOps kerak, lekin faqat oyiga 40–50 soatga. Shtatga olish bunday hollarda qimmat.",
            },
            {
                t: "Startaplar",
                d: "Texnik jamoa hali yo'q, mahsulotni tez chiqarish kerak. Investitsiya kelgach jamoani o'z ichingizga o'tkazishingiz mumkin.",
            },
            {
                t: "Xorijiy kompaniyalar",
                d: "O'zbekistonda vakolatxona ochmasdan, mahalliy narxda malakali jamoa bilan ishlash. Aloqa ingliz yoki rus tilida olib boriladi.",
            },
            {
                t: "Dasturchisi ketgan loyihalar",
                d: "Tizim ishlayapti, lekin uni kim qurgani noma'lum va hujjat yo'q. Biz auditdan boshlaymiz va keyin qo'llab-quvvatlashni olamiz.",
            },
            {
                t: "Mavsumiy yuklamasi borlar",
                d: "Savdo mavsumida ish ko'payadi, keyin tinchiydi. Jamoani mavsumga qarab kengaytirib-qisqartirish mumkin.",
            },
            {
                t: "Ichki mahsulot rivojlantiruvchilar",
                d: "CRM, ERP yoki portal doimiy yangilanadi. Bunday ish loyiha emas, jarayon — va unga doimiy jamoa kerak bo'ladi.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "IT autsorsing qancha turadi",
        sub: "Bu xizmat oylik to'lov asosida ishlaydi. Quyida odatiy tariflar va ularning farqi.",
        note:
            "Ikki model mavjud. Soatbay model: stavka 150 000 so'mdan, minimal hajm oyiga 20 soat, faktura faqat ishlangan soatlar uchun chiqadi — bu ish hajmi oldindan aniq bo'lmaganda qulay. Oylik model: mutaxassis vaqti to'liq sizga ajratiladi va soatning o'rtacha narxi 25–35% arzonroq tushadi. Aniq summa mutaxassis darajasiga (junior / middle / senior) va yo'nalishga bog'liq bo'lib, konsultatsiyadan keyin 1–2 kun ichida beriladi. Minimal muddat: bitta mutaxassis uchun 2 oy, jamoa uchun 3 oy. Keyin shartnoma bir oylik ogohlantirish bilan istalgan vaqtda to'xtatiladi, jarima yo'q. Narxga kirmaydi: bulut serverlar, uchinchi tomon obunalari (to'lov tizimi, SMS, xarita, analitika) va litsenziyali kutubxonalar — ular sizning nomingizga rasmiylashtiriladi. Narxlarga QQS kiritilmagan.",
        tiers: [
            {
                name: "Mutaxassis",
                tagline: "Bitta dasturchi to'liq bandlikda",
                price: "16 000 000",
                priceNote: "so'm / oyiga",
                term: "Minimal 2 oy",
                best: "Doimiy, lekin bitta odam ko'taradigan hajmdagi ish",
                features: [
                    "Bitta mutaxassis, oyiga ~160 soat",
                    "Yo'nalishni siz tanlaysiz: frontend, backend, mobil, QA yoki DevOps",
                    "Sizning vazifa tizimingizda ishlash (Jira, Trello, Notion)",
                    "Kunlik stand-up va haftalik demo",
                    "Texnik rahbar tomonidan kod tekshiruvi",
                    "Kasallik va ta'til vaqtida o'rin bosuvchi",
                    "Texnika, litsenziya va ish joyi bizda",
                    "Kod sizning repozitoriyingizda",
                ],
            },
            {
                name: "Jamoa",
                tagline: "3–4 kishilik jamoa",
                price: "48 000 000",
                priceNote: "so'm / oyiga",
                term: "Minimal 3 oy",
                best: "To'liq mahsulot ustida doimiy ishlash",
                featured: true,
                features: [
                    "Backend, frontend, QA va qisman dizayner",
                    "Loyiha menejeri va texnik rahbar narxga kiradi",
                    "Ikki haftalik sprintlar va yo'l xaritasi",
                    "Har sprint oxirida demo va hisobot",
                    "Kod tekshiruvi, testlash va texnik hujjat majburiy",
                    "DevOps: CI/CD, monitoring va zaxira nusxa",
                    "Jamoa tarkibini oy sayin moslashtirish",
                    "Barcha kod va huquqlar sizga tegishli",
                ],
            },
            {
                name: "Kengaytirilgan jamoa",
                tagline: "5+ mutaxassis, bir nechta yo'nalish",
                price: "110 000 000",
                priceNote: "so'mdan / oyiga",
                term: "Minimal 6 oy",
                best: "Doimiy mahsulot rivoji va parallel yo'nalishlar",
                features: [
                    "5 tadan ortiq mutaxassisdan iborat maxsus jamoa",
                    "Veb, mobil, DevOps va ma'lumot tahlili parallel",
                    "Sizning jarayoningizga to'liq integratsiya",
                    "Arxitektura va texnik strategiya bo'yicha maslahat",
                    "Kelishilgan SLA va javob berish muddatlari",
                    "Kengaytirilgan xavfsizlik talablari va alohida NDA",
                    "Jamoani bosqichma-bosqich shtatingizga o'tkazish imkoniyati",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "Hamkorlik qanday boshlanadi",
        sub: "Birinchi suhbatdan ishning boshlanishigacha odatda 1–2 hafta.",
        steps: [
            {
                t: "Bepul konsultatsiya",
                time: "1–2 kun",
                d: "Vazifangiz, texnologiyalar va hajmni muhokama qilamiz. Qaysi mutaxassislar, qaysi darajada va qancha muddatga kerakligini aytamiz.",
            },
            {
                t: "Jamoa tarkibini kelishish",
                time: "2–4 kun",
                d: "Nomzodlarni CV va oldingi ishlari bilan taklif qilamiz. Xohlasangiz, texnik suhbatni o'zingiz o'tkazasiz va tanlaysiz.",
            },
            {
                t: "Shartnoma va NDA",
                time: "1–2 kun",
                d: "Model (soatbay yoki oylik), summa, muddat, maxfiylik va intellektual mulk huquqlari yozma rasmiylashtiriladi.",
            },
            {
                t: "Kirish va onboarding",
                time: "3–5 kun",
                d: "Mutaxassis repozitoriy, server va vazifa tizimingizga ulanadi, mavjud kodni o'rganadi va birinchi kichik vazifalarni oladi.",
            },
            {
                t: "Sinov davri",
                time: "2 hafta",
                d: "Birinchi ikki hafta — sinov. Mutaxassis darajasi yoki muloqoti mos kelmasa, uni bepul almashtiramiz.",
            },
            {
                t: "Doimiy ish",
                time: "davomiy",
                d: "Sprintlar bo'yicha ish, kunlik stand-up, haftalik demo. Jamoa hajmi ehtiyojga qarab har oy o'zgartiriladi.",
            },
            {
                t: "Oylik hisobot",
                time: "har oy",
                d: "Bajarilgan vazifalar, sarflangan soatlar va keyingi oy rejasi bitta hujjatda beriladi. Soatbay modelda faktura shunga asoslanadi.",
            },
            {
                t: "To'xtatish yoki o'tkazish",
                time: "1 oy",
                d: "Shartnoma bir oylik ogohlantirish bilan yopiladi. Bu vaqtda hujjatlar topshiriladi yoki jamoa sizning shtatingizga o'tkaziladi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Autsorsing modelida olib borilgan loyihalar",
        sub: "Logistika, marketpleys, ta'lim va veterinariya — har birida jamoa mijozning jarayoni ichida ishlagan, kod esa mijoz repozitoriyasida qolgan.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["logistatrans-app", "anibla", "besh-market-app", "elma-lms", "firewise-app"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "IT autsorsing bo'yicha eng ko'p so'raladigan savollar va qisqa javoblar.",
        items: [
            {
                q: "IT autsorsing qancha turadi?",
                a: "Bitta mutaxassis to'liq bandlikda oyiga 16 000 000 so'mdan boshlanadi. 3–4 kishilik jamoa, loyiha menejeri va texnik rahbar bilan, oyiga 48 000 000 so'mdan. Kengaytirilgan jamoa 110 000 000 so'mdan. Soatbay model ham bor: stavka 150 000 so'mdan, minimal hajm oyiga 20 soat. Aniq summa mutaxassis darajasi va yo'nalishga bog'liq.",
            },
            {
                q: "Soatbay va oylik modelning farqi nima?",
                a: "Soatbay modelda siz faqat ishlangan soatlarga to'laysiz va hajm har oy o'zgarishi mumkin — bu ish aniq bo'lmaganda qulay. Oylik modelda mutaxassis vaqti to'liq sizga ajratiladi, u boshqa loyihaga o'tmaydi va soatning o'rtacha narxi 25–35% arzonroq tushadi. Doimiy ish uchun ikkinchisi deyarli har doim foydaliroq.",
            },
            {
                q: "Jamoa tarkibida kimlar bo'ladi?",
                a: "Bazaviy tarifda bitta mutaxassis: yo'nalishni siz tanlaysiz. Jamoa tarifida odatda bitta backend, bitta frontend, bitta QA muhandisi va qisman bandlikdagi dizayner bo'ladi. Ustiga loyiha menejeri va texnik rahbar qo'shiladi — ular narxga kiradi, alohida to'lanmaydi. Kengaytirilgan jamoada DevOps va analitik ham bo'ladi.",
            },
            {
                q: "Dasturchini o'zim yollaganim arzonroq emasmi?",
                a: "Faqat maoshni solishtirsangiz — ha. Lekin hisobga soliq, ta'til, kasallik varaqasi, noutbuk, litsenziya, ish joyi, ishga qabul xarajati va bo'sh turgan vaqtni qo'shsangiz, farq sezilarli kamayadi. Bundan tashqari, autsorsingda ortingizda jamoa turadi: mutaxassis ketsa yoki kasal bo'lsa, loyiha to'xtab qolmaydi.",
            },
            {
                q: "Mutaxassisni o'zim tanlay olamanmi?",
                a: "Ha. Biz nomzodlarni CV va oldingi loyihalari bilan taklif qilamiz, siz esa texnik suhbat o'tkazib tanlaysiz. Bu odatiy amaliyot va uni rad etmaymiz. Birinchi ikki hafta sinov davri hisoblanadi: daraja yoki muloqot uslubi mos kelmasa, mutaxassisni bepul almashtiramiz va yangi odamning kirish vaqti hisoblanmaydi.",
            },
            {
                q: "Kommunikatsiya qanday tashkil qilinadi?",
                a: "Har kuni 15 daqiqalik stand-up o'tkaziladi — sizning vaqtingizga moslab. Vazifalar Jira, Trello yoki Notionda yuritiladi, kundalik aloqa Slack yoki Telegramda boradi. Har hafta demo qilinadi, oy oxirida esa bajarilgan ishlar va sarflangan soatlar hisoboti beriladi. Barcha yozishmalar sizning kanallaringizda qoladi.",
            },
            {
                q: "Kod kimga tegishli bo'ladi?",
                a: "Sizga. Ish birinchi kundan sizning Git repozitoriyingizda olib boriladi, barcha intellektual mulk huquqlari esa shartnomada sizga biriktiriladi. Bu qoida dizayn manbalari, texnik hujjatlar va server sozlama fayllariga ham tegishli. Biz hech qanday kalitni ushlab turmaymiz va shartnoma to'xtaganda hech narsani bloklamaymiz — olib ketadigan narsaning o'zi yo'q.",
            },
            {
                q: "Maxfiylik qanday ta'minlanadi?",
                a: "Har bir hamkorlik NDA bilan boshlanadi — u shartnomaning ajralmas qismi. Loyihada ishlaydigan har bir mutaxassis alohida maxfiylik majburiyatini imzolaydi. Kirish huquqlari minimal darajada beriladi va ish tugagach bekor qilinadi. Shaxsiy yoki to'lov ma'lumotlari bo'lsa, ish alohida muhitda va cheklangan kirish bilan olib boriladi.",
            },
            {
                q: "Shartnomani qachon to'xtatsam bo'ladi?",
                a: "Minimal muddat tugagach — bitta mutaxassis uchun 2 oy, jamoa uchun 3 oy — bir oylik ogohlantirish bilan istalgan vaqtda. Jarima yoki yashirin to'lov yo'q. Oxirgi oy davomida hujjatlar, kirish huquqlari va tugallanmagan vazifalar ro'yxati rasman topshiriladi, shunda keyingi jamoa noldan boshlamaydi.",
            },
            {
                q: "Masofadan ishlaysizmi yoki bizning ofisimizda?",
                a: "Odatda masofadan — bu tezroq va arzonroq. Zarur bo'lsa, mutaxassis haftada bir-ikki kun ofisingizda bo'lishi yoki gibrid tartibda ishlashi mumkin, bu shartnomada alohida yoziladi. Toshkentdan tashqaridagi mijozlar bilan to'liq masofadan ishlaymiz: kunlik stand-up va demo shu tartibda ham muammosiz o'tadi.",
            },
        ],
    },

    cta: {
        h: "Jamoangizni kuchaytiramizmi?",
        p: "Bepul konsultatsiyada vazifangizni baholaymiz, qanday mutaxassislar va qancha muddatga kerakligini aytamiz. Suhbat 30 daqiqa, majburiyat yo'q. Qo'ng'iroq: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/services/it-autsorsing-hero.webp",
            alt: "IT autsorsing jamoasi mijoz loyihasi ustida ishlamoqda — dasturchi va texnik rahbar",
            caption: "Jamoa sizning jarayoningiz ichida ishlaydi: sizning vazifa tizimingiz, sizning prioritetlaringiz.",
            prompt:
                "Wide hero image of a modern open-plan software development office. Three to four developers at desks with dual monitors showing code editors and a Kanban board on a wall screen. Neutral grey and blue tones, daylight from large windows, shallow depth of field, no visible faces, no readable logos. Photographic, 16:9, calm and professional.",
        },
        {
            src: "/assets/img/services/it-autsorsing-standup.webp",
            alt: "Kunlik stand-up: masofaviy jamoa va mijoz 15 daqiqalik videoqo'ng'iroqda",
            caption: "Har kuni 15 daqiqalik stand-up — sizning vaqtingizga moslab o'tkaziladi.",
            prompt:
                "A daily stand-up meeting shown as a video call grid on a laptop screen, with a Jira-like sprint board open in a second window. Abstract avatars instead of real faces, clean UI, soft office background, warm light. Photographic with screen detail, 16:9.",
        },
        {
            src: "/assets/img/services/it-autsorsing-model.webp",
            alt: "Soatbay va oylik autsorsing modeli taqqoslovi: narx, hajm va moslashuvchanlik",
            caption: "Soatbay model — noaniq hajm uchun, oylik model — doimiy ish uchun 25–35% arzonroq.",
            prompt:
                "Clean flat infographic comparing two engagement models side by side: hourly billing versus monthly dedicated team. Two columns with simple icons (clock versus calendar), bar indicators for cost and flexibility. Muted blue and grey palette, generous white space, no text that must be readable. Vector style, 16:9.",
        },
        {
            src: "/assets/img/services/it-autsorsing-team.webp",
            alt: "Autsorsing jamoasi tarkibi: backend, frontend, QA, dizayner, loyiha menejeri",
            caption: "Odatiy jamoa: backend, frontend, QA, qisman dizayner, ustiga menejer va texnik rahbar.",
            prompt:
                "Organizational diagram of a small software team rendered as clean cards on a neutral canvas: backend, frontend, QA, designer, project manager and tech lead, connected with thin lines. Minimal icons, muted palette, plenty of spacing, documentation-page look. Flat vector, 16:9.",
        },
    ],

    related: ["texnik-qollab-quvvatlash", "veb-ilovalar", "crm-tizimlar", "mobil-ilova"],
};

const ru = {
    meta: {
        title: "IT-аутсорсинг — разработчик и команда от 16 млн сум в месяц | Innobek",
        description:
            "IT-аутсорсинг: опытный разработчик или полноценная команда от 16 000 000 сум в месяц. Без найма, налогов и отпусков. Код ваш, NDA, пробный период 2 недели.",
        keywords: [
            "it аутсорсинг",
            "аренда разработчиков",
            "выделенная команда",
            "dedicated team",
            "удалённый разработчик",
            "стоимость it аутсорсинга",
            "аутсорсинг разработки",
            "аутсорсинг it отдела",
        ],
    },

    hero: {
        eyebrow: "IT-аутсорсинг",
        h1: "IT-аутсорсинг: готовая команда в аренду помесячно",
        lead:
            "Чтобы построить собственный IT-отдел, нужны найм, налоги, отпуска и техника — это обычно 3–6 месяцев и заметные деньги. В аутсорсинге вы платите за работающую команду: разработчик подключается за 1–2 недели, а код с первого дня лежит в вашем репозитории.",
        ctaPrimary: "Оставить заявку на команду",
        ctaSecondary: "Посмотреть цены и модели",
        proof: [
            "200+ сданных проектов",
            "Старт за 1–2 недели",
            "Код и права полностью ваши",
            "NDA в каждом сотрудничестве",
            "Первые 2 недели — пробный период",
        ],
    },

    intro: {
        h: "Что такое IT-аутсорсинг и кому он выгоден",
        p: [
            "IT-аутсорсинг — это привлечение специалистов из внешней команды вместо содержания разработчиков в собственном штате. Вы ставите задачу, мы выделяем разработчика, тестировщика, дизайнера или DevOps-инженера. Они работают на вашем проекте, по вашим приоритетам и по вашему графику.",
            "Главное отличие — в структуре расходов. За штатного разработчика вы платите не только оклад, но и налоги, отпуск, больничные, технику, лицензии и рабочее место. Сам наём занимает от одного до трёх месяцев и не всегда даёт результат. В аутсорсинге всё это входит в одну месячную сумму, известную заранее.",
            "Для Innobek аутсорсинг — не «продажа часов». За каждым проектом закреплён технический руководитель: он отвечает за архитектуру, качество кода и сроки. Вам не нужно ежедневно контролировать разработчика — есть ежедневный стендап, еженедельное демо и отчёт о выполненных работах в конце месяца.",
            "Модель вы выбираете сами. Если объём работ плавающий, удобнее почасовая: часы считаются, счёт выставляется по факту. Если работа постоянная, месячная модель выходит на 25–35% дешевле в пересчёте на час — время специалиста закреплено за вами и не уходит на другие проекты.",
            "Вопрос о правах на код возникает почти всегда, поэтому отвечаем прямо: весь код, исходники дизайна и документация принадлежат вам. Работа с первого дня ведётся в вашем Git-репозитории. Мы не держим ключи у себя и ничего не блокируем при прекращении договора.",
            "Услуга подходит не всем. Если задача разовая — например, одна посадочная страница — заказать её как проект дешевле, и мы скажем об этом честно. Аутсорсинг окупается, когда работа постоянная и растянута на месяцы, а внутри компании некому её вести.",
        ],
    },

    definition: {
        term: "Что такое IT-аутсорсинг?",
        text:
            "IT-аутсорсинг — привлечение разработчика или целой команды внешнего партнёра на условиях ежемесячной или почасовой оплаты вместо содержания IT-специалистов в штате. Специалист работает внутри процессов заказчика, а код и права остаются у заказчика.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не платные «допы» — всё перечисленное есть и в базовых условиях.",
        items: [
            "Бесплатная консультация и оценка объёма задачи",
            "Подбор кандидатов и их представление вам",
            "Возможность самостоятельно провести техническое собеседование",
            "Пробный период: если специалист в первые 2 недели не подошёл — меняем",
            "Ноутбук, лицензии и рабочее место на нашей стороне",
            "Все вопросы налогов и трудовых отношений на нашей стороне",
            "Ежедневный стендап — 15 минут, в удобное вам время",
            "Ведение задач в Jira, Trello или Notion",
            "Ежедневный канал связи в Slack или Telegram",
            "Code review со стороны технического руководителя",
            "Еженедельное демо и месячный отчёт о работах",
            "Работа в вашем Git-репозитории",
            "Соглашение о конфиденциальности (NDA) и контроль доступов",
            "Замена специалиста на время болезни и отпуска",
            "Прекращение договора с уведомлением за месяц",
        ],
    },

    benefits: {
        eyebrow: "Что это даёт",
        h: "Что аутсорсинг даёт бизнесу",
        sub: "Это не дешёвая замена найму, а другая модель управления ресурсом.",
        items: [
            {
                t: "Быстрый старт",
                d: "От вакансии до первого рабочего дня обычно проходит 1–3 месяца. В аутсорсинге специалист входит в проект за 1–2 недели и сразу берёт задачи.",
            },
            {
                t: "Расходы известны заранее",
                d: "Налоги, отпуска, больничные, техника и лицензии уже внутри месячной суммы. В бюджете не появляется неожиданных статей.",
            },
            {
                t: "Объём подстраивается",
                d: "В активной фазе команда расширяется, в спокойной — сокращается. Без увольнений, компенсаций и неприятных разговоров.",
            },
            {
                t: "Вы не зависите от одного человека",
                d: "Если разработчик заболел или ушёл, его заменяют внутри команды. Документация и код у вас, поэтому передача занимает 2–3 дня.",
            },
            {
                t: "Качество контролируется",
                d: "Code review, документация и внутренние стандарты обязательны. При найме одного разработчика его код обычно никто не проверяет.",
            },
            {
                t: "Добираете недостающую экспертизу",
                d: "DevOps, мобильная разработка или тестирование нужны под конкретный проект. Держать их в штате невыгодно, а частичная занятость закрывает вопрос.",
            },
            {
                t: "Процесс остаётся на вашей стороне",
                d: "Специалист работает в вашей системе задач и на ваших встречах. Управление не уходит на сторону вместе с исполнителем.",
            },
            {
                t: "Позже можно перевести в штат",
                d: "Если продукт вырос и вы решили строить свою команду, условия поэтапного перевода согласуются отдельно.",
            },
            {
                t: "Есть обмен опытом",
                d: "За специалистом стоят команда, техлид и опыт других проектов. Со сложной задачей он не остаётся один на один.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Кому подходит IT-аутсорсинг",
        sub: "Случаи, когда свой IT-отдел содержать пока рано или невыгодно вовсе.",
        items: [
            {
                t: "Компании без IT-отдела",
                d: "Нужен сайт, внутренняя система или приложение, но постоянный разработчик не окупается: объём тянет максимум на полставки.",
            },
            {
                t: "Команды под дедлайном",
                d: "Свои разработчики есть, но релиз близко. Мы подключаемся как дополнительная мощность и завершаем работу после релиза.",
            },
            {
                t: "Недостающее направление",
                d: "Есть бэкенд, нет мобильного разработчика. Или нужен DevOps, но всего на 40–50 часов в месяц. Держать такого человека в штате дорого.",
            },
            {
                t: "Стартапы",
                d: "Технической команды ещё нет, а продукт нужно выпустить быстро. После инвестиций команду можно перевести к себе.",
            },
            {
                t: "Зарубежные компании",
                d: "Квалифицированная команда по местным ставкам без открытия представительства в Узбекистане. Общение на русском или английском.",
            },
            {
                t: "Проекты без прежнего разработчика",
                d: "Система работает, но кто её собрал — неизвестно, документации нет. Начинаем с аудита и затем берём поддержку на себя.",
            },
            {
                t: "Бизнес с сезонной нагрузкой",
                d: "В сезон работы много, потом затишье. Команду расширяют и сокращают по календарю, а не по штатному расписанию.",
            },
            {
                t: "Владельцы внутренних продуктов",
                d: "CRM, ERP или портал развиваются постоянно. Это не проект с конечной датой, а процесс, которому нужна постоянная команда.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Сколько стоит IT-аутсорсинг",
        sub: "Услуга работает по ежемесячной оплате. Ниже типовые тарифы и разница между ними.",
        note:
            "Доступны две модели. Почасовая: ставка от 150 000 сум при минимальном объёме 20 часов в месяц, счёт — только за отработанные часы. Месячная: время специалиста закреплено за вами полностью, средняя стоимость часа на 25–35% ниже. Итоговая сумма зависит от уровня специалиста (junior / middle / senior) и направления. Минимальный срок — 2 месяца для одного специалиста и 3 месяца для команды, дальше договор прекращается с уведомлением за месяц и без штрафов. Не входят: облачные серверы, подписки сторонних сервисов (платежи, SMS, карты, аналитика) и коммерческие лицензии — они оформляются на ваше юрлицо. Цены без НДС.",
        tiers: [
            {
                name: "Специалист",
                tagline: "Один разработчик на полной занятости",
                price: "16 000 000",
                priceNote: "сум / месяц",
                term: "Минимум 2 месяца",
                best: "Постоянному объёму работ, который тянет один человек",
                features: [
                    "Один специалист, около 160 часов в месяц",
                    "Направление выбираете вы: frontend, backend, mobile, QA или DevOps",
                    "Работа в вашей системе задач (Jira, Trello, Notion)",
                    "Ежедневный стендап и еженедельное демо",
                    "Code review со стороны технического руководителя",
                    "Замена на время болезни и отпуска",
                    "Техника, лицензии и рабочее место на нашей стороне",
                    "Код в вашем репозитории",
                ],
            },
            {
                name: "Команда",
                tagline: "Команда из 3–4 человек",
                price: "48 000 000",
                priceNote: "сум / месяц",
                term: "Минимум 3 месяца",
                best: "Постоянной работе над полноценным продуктом",
                featured: true,
                features: [
                    "Бэкенд, фронтенд, QA и дизайнер на частичной занятости",
                    "Менеджер проекта и технический руководитель входят в стоимость",
                    "Двухнедельные спринты и дорожная карта",
                    "Демо и отчёт в конце каждого спринта",
                    "Обязательные code review, тестирование и документация",
                    "DevOps: CI/CD, мониторинг и резервное копирование",
                    "Корректировка состава команды каждый месяц",
                    "Весь код и права принадлежат вам",
                ],
            },
            {
                name: "Расширенная команда",
                tagline: "5+ специалистов, несколько направлений",
                price: "110 000 000",
                priceNote: "сум / месяц, от",
                term: "Минимум 6 месяцев",
                best: "Постоянному развитию продукта и параллельным направлениям",
                features: [
                    "Выделенная команда из пяти и более специалистов",
                    "Веб, мобильная разработка, DevOps и аналитика параллельно",
                    "Полная интеграция в ваши процессы",
                    "Консультации по архитектуре и технической стратегии",
                    "Согласованный SLA и время реакции",
                    "Расширенные требования безопасности и отдельные NDA",
                    "Возможность поэтапного перевода команды в ваш штат",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как начинается сотрудничество",
        sub: "От первого разговора до начала работ обычно проходит 1–2 недели.",
        steps: [
            {
                t: "Бесплатная консультация",
                time: "1–2 дня",
                d: "Обсуждаем задачу, технологии и объём. Говорим, какие специалисты и на какой срок нужны.",
            },
            {
                t: "Согласование состава",
                time: "2–4 дня",
                d: "Предлагаем кандидатов с резюме и примерами работ. При желании вы сами проводите техническое собеседование.",
            },
            {
                t: "Договор и NDA",
                time: "1–2 дня",
                d: "Фиксируем модель (почасовая или месячная), сумму, срок, конфиденциальность и права на интеллектуальную собственность.",
            },
            {
                t: "Доступы и онбординг",
                time: "3–5 дней",
                d: "Специалист подключается к репозиторию, серверам и системе задач, изучает код и берёт первые задачи.",
            },
            {
                t: "Пробный период",
                time: "2 недели",
                d: "Первые две недели считаются пробными. Если уровень или стиль общения не подошёл, меняем бесплатно.",
            },
            {
                t: "Постоянная работа",
                time: "постоянно",
                d: "Спринты, ежедневный стендап, еженедельное демо. Размер команды меняется под потребность каждый месяц.",
            },
            {
                t: "Ежемесячный отчёт",
                time: "каждый месяц",
                d: "Выполненные задачи, потраченные часы и план на следующий месяц в одном документе. В почасовой модели счёт строится на нём.",
            },
            {
                t: "Завершение или перевод",
                time: "1 месяц",
                d: "Договор закрывается с уведомлением за месяц. За это время передаём документацию, доступы и незакрытые задачи.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Проекты, которые мы вели в модели аутсорсинга",
        sub: "Логистика, маркетплейс, образование и ветеринария — команда работала внутри процессов клиента, код оставался в его репозитории.",
        cta: "Смотреть все проекты",
        slugs: ["logistatrans-app", "anibla", "besh-market-app", "elma-lms", "firewise-app"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Коротко отвечаем на частые вопросы об IT-аутсорсинге.",
        items: [
            {
                q: "Сколько стоит IT-аутсорсинг?",
                a: "Один специалист на полной занятости — от 16 000 000 сум в месяц. Команда из 3–4 человек с менеджером проекта и техлидом — от 48 000 000 сум в месяц. Расширенная команда — от 110 000 000 сум. Есть и почасовая модель: ставка от 150 000 сум при минимальном объёме 20 часов в месяц. Точная сумма зависит от уровня специалиста и направления.",
            },
            {
                q: "Чем почасовая модель отличается от месячной?",
                a: "В почасовой вы платите только за отработанные часы, и объём может меняться от месяца к месяцу — это удобно, когда работа нерегулярная. В месячной время специалиста закреплено за вами целиком, он не переключается на другие проекты, а средняя стоимость часа выходит на 25–35% ниже. Для постоянной работы вторая модель почти всегда выгоднее.",
            },
            {
                q: "Кто входит в состав команды?",
                a: "В базовом тарифе один специалист, направление выбираете вы. В тарифе «Команда» обычно это бэкенд-разработчик, фронтенд-разработчик, QA-инженер и дизайнер на частичной занятости. Сверху добавляются менеджер проекта и технический руководитель — они входят в стоимость и отдельно не оплачиваются. В расширенной команде появляются DevOps и аналитик.",
            },
            {
                q: "Разве нанять разработчика самому не дешевле?",
                a: "Если сравнивать только оклад — да. Но добавьте налоги, отпуск, больничные, ноутбук, лицензии, рабочее место, стоимость найма и простои — разрыв заметно сокращается. Плюс в аутсорсинге за специалистом стоит команда: если он уходит или заболевает, проект не останавливается и вы не начинаете поиск заново.",
            },
            {
                q: "Могу ли я сам выбрать специалиста?",
                a: "Да. Мы предлагаем кандидатов с резюме и примерами прошлых проектов, вы проводите техническое собеседование и выбираете. Это обычная практика, и мы от неё не отказываемся. Первые две недели считаются пробным периодом: если уровень или стиль общения не подошли, меняем специалиста бесплатно и не берём оплату за время, пока новый входит в проект.",
            },
            {
                q: "Как выстроена коммуникация?",
                a: "Каждый день проводится стендап на 15 минут в удобное вам время. Задачи ведутся в Jira, Trello или Notion, ежедневное общение идёт в Slack или Telegram. Раз в неделю показываем демо, в конце месяца отдаём отчёт по выполненным работам и потраченным часам. Вся переписка остаётся в ваших каналах и доступна вам всегда.",
            },
            {
                q: "Кому принадлежит код?",
                a: "Вам. Работа с первого дня ведётся в вашем Git-репозитории, а все права на интеллектуальную собственность закрепляются за вами в договоре. То же касается исходников дизайна, технической документации и конфигураций. Мы не держим ключи у себя и ничего не блокируем при прекращении сотрудничества — забирать нечего, всё уже у вас.",
            },
            {
                q: "Как обеспечивается конфиденциальность?",
                a: "Каждое сотрудничество начинается с NDA, который является частью договора. Каждый специалист на проекте подписывает отдельное обязательство о неразглашении. Доступы выдаются по принципу минимально необходимых прав и отзываются по завершении работ. Если в системе есть персональные или платёжные данные, работа ведётся в отдельной среде с ограниченным доступом.",
            },
            {
                q: "Когда можно прекратить договор?",
                a: "После минимального срока — 2 месяца для одного специалиста и 3 месяца для команды — в любой момент с уведомлением за месяц. Штрафов и скрытых платежей нет. В течение последнего месяца мы официально передаём документацию, доступы и список незавершённых задач, чтобы следующая команда не начинала с нуля.",
            },
            {
                q: "Вы работаете удалённо или в нашем офисе?",
                a: "Обычно удалённо — так быстрее и дешевле. При необходимости специалист может один-два дня в неделю работать в вашем офисе или в гибридном режиме, это отдельно фиксируется в договоре. С клиентами за пределами Ташкента работаем полностью удалённо: ежедневные стендапы и демо в таком формате проходят без проблем.",
            },
        ],
    },

    cta: {
        h: "Усилим вашу команду?",
        p: "На бесплатной консультации оценим задачу и скажем, какие специалисты и на какой срок нужны. Разговор занимает 30 минут, без обязательств. Звоните: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/services/it-autsorsing-hero.webp",
            alt: "Команда IT-аутсорсинга работает над проектом клиента: разработчики и технический руководитель",
            caption: "Команда работает внутри ваших процессов: ваша система задач, ваши приоритеты.",
            prompt:
                "Wide hero image of a modern open-plan software development office. Three to four developers at desks with dual monitors showing code editors and a Kanban board on a wall screen. Neutral grey and blue tones, daylight from large windows, shallow depth of field, no visible faces, no readable logos. Photographic, 16:9, calm and professional.",
        },
        {
            src: "/assets/img/services/it-autsorsing-standup.webp",
            alt: "Ежедневный стендап: удалённая команда и клиент на 15-минутном видеозвонке",
            caption: "Ежедневный стендап на 15 минут — в удобное вам время.",
            prompt:
                "A daily stand-up meeting shown as a video call grid on a laptop screen, with a Jira-like sprint board open in a second window. Abstract avatars instead of real faces, clean UI, soft office background, warm light. Photographic with screen detail, 16:9.",
        },
        {
            src: "/assets/img/services/it-autsorsing-model.webp",
            alt: "Сравнение почасовой и месячной модели аутсорсинга: цена, объём и гибкость",
            caption: "Почасовая модель — для плавающего объёма, месячная — на 25–35% дешевле при постоянной работе.",
            prompt:
                "Clean flat infographic comparing two engagement models side by side: hourly billing versus monthly dedicated team. Two columns with simple icons (clock versus calendar), bar indicators for cost and flexibility. Muted blue and grey palette, generous white space, no text that must be readable. Vector style, 16:9.",
        },
        {
            src: "/assets/img/services/it-autsorsing-team.webp",
            alt: "Состав команды аутсорсинга: бэкенд, фронтенд, QA, дизайнер и менеджер проекта",
            caption: "Типовая команда: бэкенд, фронтенд, QA, дизайнер частично, плюс менеджер и техлид.",
            prompt:
                "Organizational diagram of a small software team rendered as clean cards on a neutral canvas: backend, frontend, QA, designer, project manager and tech lead, connected with thin lines. Minimal icons, muted palette, plenty of spacing, documentation-page look. Flat vector, 16:9.",
        },
    ],

    related: ["texnik-qollab-quvvatlash", "veb-ilovalar", "crm-tizimlar", "mobil-ilova"],
};

const content = { uz, ru };

export default content;
